<template>
  <generic-container
    v-bind:show_plus="true"
    icon="time"
    :title="$t('studying time')"
    v-on:add="add"
  >
    <div class="ui three cards" v-if="setup && setup.std_studying_times">
      <div
        class="card"
        v-for="(time, index) in setup.std_studying_times"
        v-bind:key="index"
      >
        <div class="content">
          <div class="header">{{ time.name }}</div>
          <div class="description">{{ time.name }}</div>
        </div>
        <div class="ui bottom attached basic buttons">
          <div class="ui button" @click="set_up(time)">
            <i class="settings icon"></i>
            {{ $t("configure") }}
          </div>
          <div class="ui button" @click="remove(time, index)">
            <i class="red trash icon"></i>
            {{ $t("delete") }}
          </div>
        </div>
      </div>
    </div>
    <template v-for="(mdl, index) in time_modals">
      <component
        :is="mdl"
        :key="index"
        :time_uuid="selected_time.uuid"
        @updated="finish"
      ></component>
    </template>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { local_api, stringify } from "@/utils";
import timeModal from "../studying_time_modal/StudentTimeModalIndex";

export default {
  name: "StudentConfigurationModalStudyingTime",
  components: {
    GenericContainer,
  },
  props: {
    setup: Object,
  },
  data() {
    return {
      time_modals: [],
      selected_time: {},
    };
  },
  methods: {
    add() {
      let vm = this;
      vm.$alertify.prompt(this.$t("enter time name"), "", function(
        element,
        value,
      ) {
        local_api(
          vm,
          "post",
          "/student_configuration/do-create-studying-time",
          {
            n: value,
          },
        )
          .then((l) => {
            if (vm.setup && !vm.setup.std_studying_times)
              vm.setup.std_studying_times = [];
            vm.setup.std_studying_times.push(l);
          })
          .catch((err) => {
            vm.$alertify.error(stringify(err));
          });
      });
    },
    remove(time, index) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove studying time?"),
        function() {
          local_api(
            vm,
            "post",
            "/student_configuration/do-remove-studying-time",
            {
              u: time.uuid,
            },
          )
            .then(() => {
              vm.setup.std_studying_times.splice(index, 1);
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            });
        },
      );
    },
    set_up(time) {
      this.selected_time = time;
      this.time_modals.push(timeModal);
    },
    finish(data) {
      let trgt = this.setup.std_studying_times.find((n) => n.uuid == data.uuid);
      if (trgt) {
        trgt.name = data.name;
      }
    },
  },
};
</script>
